import { defineMessages } from "react-intl";
export default defineMessages({
  smartMixinDescription: {
    "id": "landing.smartMixinDescription",
    "defaultMessage": "SmartMixin is an application that provides access to your weather station and 40K+ other stations worldwide. It helps you see and understand weather data."
  },
  weatherAssistant: {
    "id": "landing.weatherAssistant",
    "defaultMessage": "Your weather assistant"
  },
  weatherAssistantDescription: {
    "id": "landing.weatherAssistantDescription",
    "defaultMessage": "Whether you are interested in current, historical or forecast weather conditions, SmartMixin provides with numerous insights whenever you need them."
  },
  weatherAnalysis: {
    "id": "landing.weatherAnalysis",
    "defaultMessage": "Weather Analysis"
  },
  weatherAnalysisDescription: {
    "id": "landing.weatherAnalysisDescription",
    "defaultMessage": "SmartMixin comes with lots of data vizualization that lets you analyse weather data."
  },
  forecasts: {
    "id": "landing.forecasts",
    "defaultMessage": "Forecasts"
  },
  forecastDescription: {
    "id": "landing.forecastDescription",
    "defaultMessage": "Access some of the best weather forecast models and compare them to get your own idea of what the weather will be."
  },
  weatherMap: {
    "id": "landing.weatherMap",
    "defaultMessage": "Weather Map"
  },
  weatherMapDescription: {
    "id": "landing.weatherMapDescription",
    "defaultMessage": "Browse the map and vizualize what’s the weather like anywhere around the globe."
  },
  alerts: {
    "id": "landing.alerts",
    "defaultMessage": "Alerts"
  },
  alertsDescription: {
    "id": "landing.alertsDescription",
    "defaultMessage": "Create your own alerts and get notified as soon as they are triggered."
  },
  supportedDevices: {
    "id": "landing.supportedDevices",
    "defaultMessage": "Supported devices"
  },
  supportedDevicesDescription: {
    "id": "landing.supportedDevicesDescription",
    "defaultMessage": "On top of the stations from the World Meteorological Organization, SmartMixin supports a growing number of weather stations brands."
  },
  thermostatManufacturers: {
    "id": "landing.thermostatManufacturers",
    "defaultMessage": "Thermostat manufacturers are also supported to correlate heating with outdoor conditions."
  },
  weatherForecastModels: {
    "id": "landing.weatherForecastModels",
    "defaultMessage": "Weather forecast models"
  },
  weatherForecastModelsDescription: {
    "id": "landing.weatherForecastModelsDescription",
    "defaultMessage": "SmartMixin provides access to the most accurate weather forecast models. You can easily compare their forecasts and make your own idea."
  }
});